// extracted by mini-css-extract-plugin
export default {"unchecked_icon":"UncheckedIcon_unchecked_icon__fmDP9"};